export var ProgressBarHeight;
(function (ProgressBarHeight) {
    ProgressBarHeight["SMALL"] = "SMALL";
    ProgressBarHeight["LARGE"] = "LARGE";
})(ProgressBarHeight || (ProgressBarHeight = {}));
//# sourceMappingURL=ProgressBarHeight.js.map